import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { roles } from '../../constants'

export default class extends Component {
  render () {
    const { user } = this.props

    if (user.info.role === roles.ORGANIZATION_ADMIN) {
      return <Redirect to='/admin/content' />
    } else if (user.info.role === roles.GLOBAL_ADMIN) {
      return <Redirect to='/admin/divisions' />
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx